import { Component, Input, OnInit, inject, input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ContactDataService } from 'src/app/modules/user-profile/services/contact-data-service';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MdmOrgList, IdentifierList } from 'src/app/modules/user-profile/models/contact-mdm-person.model';
import { OrgEmailList, OrgCollection, EmailList } from 'src/app/modules/user-profile/models/contact-oeds-person.model';
import { AlertComponent } from '../../../../../shared/components/alert/alert.component';
import { DeleteConfirmationComponent } from '../../../../../shared/components/delete-confirmation/delete-confirmation.component';
import { CompareValidatorDirective } from '../directives/compare-validator-directive';
import { NgClass } from '@angular/common';
@Component({
    selector: 'app-contact-verification-emails-multiple',
    templateUrl: './contact-verification-emails-multiple.component.html',
    styleUrls: ['./contact-verification-emails-multiple.component.css'],
    imports: [FormsModule, ReactiveFormsModule, CompareValidatorDirective, NgClass, DeleteConfirmationComponent, AlertComponent]
})
export class ContactVerificationEmailsMultipleComponent implements OnInit {
  private router = inject(Router);
  private cdataservice = inject(ContactDataService);
  cService = inject(ContactVerificationService);
  private spinner = inject(NgxSpinnerService);


  showDelete: boolean[] = [];
  showUnusedEmails = true;
  showUsedEmails = false;
  showAddNew = false;
  showOrgForm = false;
  showAlert = false;
  npEmailCollection: EmailList[];
  newemailform: UntypedFormGroup;
  newemailindex = 0;
  emailId: string;
  remailId: string;
  deletedEmailId: any;
  deletedEmail: any;
  routeFlag = false;
  primaryEmail: string = "";
  primaryEmailKey: number = 0;
  isOrgAdded = false;
  isOrgSelected = false;
  isDuplicateEmail: boolean = false;
  isOhidInEmailList: boolean = false;
  orgEmailMapping: OrgCollection[] = [];
  readonly oedsEmailTypeKey = input<number>(undefined);
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() emailList: EmailList[];
  readonly orgEmailList = input<OrgEmailList[]>(undefined);
  sOrgId = ""; sOrgIrn = ""; sOrgname = ""; sMessageHead = "Success"; sMessage = "Your org email mapping has been added";

  ngOnInit(): void {
    this.newemailform = new UntypedFormGroup({
      emailId: new UntypedFormControl('', [Validators.required]),
      remailId: new UntypedFormControl('', [Validators.required]),
      type: new UntypedFormControl('', [Validators.required]),
      isPrimary: new UntypedFormControl('')
      //orgId: new UntypedFormControl('', [Validators.required]),
    });
    this.getOrgCollection();
    this.setPrimaryFlag();
  }
  action = 'List';
  setPrimaryFlag() {
    let activeEmailList = this.cService.filterActiveEmailByType(this.oedsEmailTypeKey(), this.cService.oedsPersonCopy.emailList)
    //If only one office email present that should be primary
    if (activeEmailList.length === 1) {
      activeEmailList.map(item => item.primaryFlag = true);
      activeEmailList.map(item => item.actionType = "Updated");
    }
  }
  getOrgCollection() {
    if (this.cService.orgList.length == 0) {
      this.spinner.show();
      var orgids = [];
      this.orgEmailList().forEach(eobj => { orgids.push(eobj.orgKey); });
      this.cdataservice.getOrgDtls(orgids).subscribe({
        next: (orglist: MdmOrgList[]) => {
          this.cService.orgList = [];
          orglist.forEach(eobj => {
            var irnlist = this.filterIdentifierType("IRN", eobj.identifierList)[0];
            const orgCollection = {} as OrgCollection;
            orgCollection.orgId = eobj.key;
            orgCollection.orgIrnNo = irnlist ? irnlist.identifierValue:"";
            orgCollection.orgName = eobj.name + "";
            let orgMapping = this.orgEmailList().find(x => x.orgKey == eobj.key);
            if (orgMapping) {
              orgMapping.orgIrnNo = irnlist ? irnlist.identifierValue : "";
              orgMapping.orgName = eobj.name + "";
              orgCollection.email = orgMapping.email;
              orgCollection.emailId = orgMapping.oedsEmailKey;
            }
            else
              orgCollection.email = "";
            this.cService.orgList.push(orgCollection);
          });
          this.filterNonPrimary();
          this.orgEmailMapping = this.cService.orgList.filter(item => item.email != "");
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          this.cService.contactVerificationFailed = true;
        }
      });
    }
    else {
      this.filterNonPrimary();
      this.orgEmailMapping = this.cService.orgList.filter(item => item.email != "");
    }
  }
  filterIdentifierType(identifiertype, objList: IdentifierList[]) {
    return objList.filter(function (obj) {
      return obj.identifierType.name == identifiertype;
    });
  }
  addEntryToEmailList(nemail, nisPrimary, ntype) {
    let nisPrvate = true;
    if (ntype == "public") {
      nisPrvate = false;
    }
    const oedsEmailTypeKey = this.oedsEmailTypeKey();
    this.cService.insertUpdateEmail(nemail, oedsEmailTypeKey, nisPrimary, nisPrvate);
    this.emailList = this.cService.filterActiveEmailByType(oedsEmailTypeKey, this.cService.oedsPersonCopy.emailList);
  }
  filtermappingemail(orgkey) {
    return this.orgEmailList().filter(function (obj) {
      return obj.orgKey == orgkey;
    });
  }

  addNewEmail(): boolean {
    if (this.emailList.some(x => x.email == this.newemailform.value.emailId)) {
      this.isDuplicateEmail = true;
      this.newemailform.reset();
      this.openConfirmModal('duplicateEmail');
      return false;
    }
    else {
      this.newemailindex++;
      this.isDuplicateEmail = false;
      var nemail = this.newemailform.value.emailId;
      let activeEmailList = this.cService.filterActiveEmailByType(this.oedsEmailTypeKey(), this.cService.oedsPersonCopy.emailList);
      //if no office eemail present default newly added email should be primary
      if (activeEmailList.length === 0) {
        this.newemailform.value.isPrimary = "true";
      }
      var nisPrimary = this.newemailform.value.isPrimary;
      var ntype = this.newemailform.value.type;
      this.updateemailcollection(nemail, nisPrimary, ntype);
      this.newemailform.reset();
      this.showAddNew = false;
      return true;
    }
  }
  updateemailcollection(nemail, nisPrimary, ntype) {
    var isprimary = false;
    if (nisPrimary == "true") {
      this.emailList.map(item => item.primaryFlag = false);
      isprimary = true;
    }
    else {
      isprimary = false;
    }

    this.addEntryToEmailList(nemail, isprimary, ntype);
    this.filterNonPrimary();
    //If new email added is primary then we should reset exiting org email mapping
    //if (nisPrimary== "true")
    //   this.resetemailmapping(nemail);
  }
  resetemailmapping(nemail) {
    this.orgEmailList().map(item => {
      item.email = nemail;
    });
  }

  filterNonPrimary() {
    this.npEmailCollection = this.emailList.filter((item) => item.primaryFlag === false);
  }
  updateIsUnused(email, orgId,emailId) {
    this.action = 'List';
    var selectedorgmapping = this.orgEmailList().find(item => item.orgKey === orgId);
    selectedorgmapping.email = "";
    selectedorgmapping.oedsEmailKey = 0;

    this.emailList.map(item => {
      //if (item.oedsEmailKey == prevemailId && item.email == prevemail) {
      var isEmailMapExist = this.orgEmailList().find(x => x.oedsEmailKey === item.oedsEmailKey && x.email === item.email);
      if (!isEmailMapExist) {
        item.isMapped = false;
      }
    });

    var org = this.cService.orgList.find(item => item.orgId === orgId);
    org.email = "";
    org.emailId = 0;
    this.orgEmailMapping = this.cService.orgList.filter(item => item.email !== "");
  }
  updateIsUsed($evt, orgId) {
    //If Selected None from email default should be mapped to Primary email
    if ($evt.value === "") {
      this.updateOrgEmailMapping(this.primaryEmail, orgId);
    } else {
      this.isOrgAdded = true;
      this.updateOrgEmailMapping($evt.value, orgId);
    }
  }
  
  updateOrgEmailMapping(email, orgId) {
    orgId = Number(orgId);
    let sEmail = this.npEmailCollection.find(x => x.email == email);

    var selectedorgmapping = this.orgEmailList().find(item => item.orgKey === orgId);
    selectedorgmapping.email = email;
    selectedorgmapping.oedsEmailKey = sEmail.oedsEmailKey;

    this.emailList.map(item => {
      var isEmailMapExist = this.orgEmailList().find(x => x.oedsEmailKey === item.oedsEmailKey && x.email === item.email);
      if (!isEmailMapExist) {
        item.isMapped = false;
      }
      if (item.oedsEmailKey === sEmail.oedsEmailKey && item.email === email) {
        item.isMapped = true;
      }
    }); 

    var org = this.cService.orgList.find(item => item.orgId === orgId);
    org.email = email;
    org.emailId = sEmail.oedsEmailKey;
  }
  mapPrimaryEmail() {
    this.orgEmailList().map(item => {
      item.email = this.primaryEmail;
    });
  }
  resetOrgEmailMapping(emailid, email) {
    this.orgEmailList().map(item => {
      if (item.oedsEmailKey === emailid && item.email === email) {
        item.email = this.primaryEmail;
      }
    });
  }
  updatetype(emailid, email, etype) {
    let semail = this.emailList.find(item => item.oedsEmailKey === emailid && item.email === email);
    if (etype === "public") {
      semail.privateFlag = false;
    }
    else {
      semail.privateFlag = true;
    }
    semail.actionType = "Updated";
  }
  updateisPrimary(emailid, email) {
    this.emailList.map(item => {
      if (item.primaryFlag === true) {
        item.primaryFlag = false;
        item.actionType = "Updated";
      }
    });

    let semail = this.emailList.find(item => item.oedsEmailKey === emailid && item.email === email);
    semail.primaryFlag = true;
    semail.actionType = "Updated";
    this.primaryEmailKey = emailid;
    this.primaryEmail = email;

    this.emailList.map(item => {
      if (item.email === email) {
        item.isMapped = false;
      }
    });
    this.orgEmailList().map(item => {
      if (item.email === email) {
        item.email = "";
        item.oedsEmailKey = 0;
      }
    });

    this.cService.orgList.map(item => {
      if (item.email === email) {
        item.email = "";
        item.emailId = 0;
      }
    });
    this.orgEmailMapping = this.cService.orgList.filter(item => item.email !== "");
    this.filterNonPrimary();
    //this.mapPrimaryEmail();
  }
  toggleshowDelete(index) {
    this.showDelete[index] = true;
  }

  toggleshowAddNew() {
    this.showAddNew = true;
  }
  togglehideHomeAddNew() {
    this.newemailform.reset();
    this.showAddNew = false;
  }
  canceldelete(index) {
    this.showDelete[index] = false;
  }
  deleteemail(emailid, email, index) {
    this.deletedEmailId = emailid;
    this.deletedEmail = email;
    this.showDelete[index] = true;
  }
  setSelectedOrg($evt) {
    if ($evt.value != "") {
      this.isOrgSelected = true;
      this.sOrgId = $evt.value;
      let org = this.cService.orgList.find(item => item.orgId + "" === this.sOrgId);
      this.sOrgIrn = org.orgIrnNo;
      this.sOrgname = $evt.options[$evt.options.selectedIndex].text
    }
  }
  delete() {
    let deletedEmail = this.emailList.find(d => d.oedsEmailKey === this.deletedEmailId && d.email === this.deletedEmail); //find index in your array
    deletedEmail.isMapped = false;
    deletedEmail.primaryFlag = false;
    deletedEmail.actionType = "Deleted";

    let index = this.emailList.findIndex(d => d.oedsEmailKey === this.deletedEmailId && d.email === this.deletedEmail); //find index in your array
    this.emailList.splice(index, 1);
    //this.resetOrgEmailMapping(this.deletedEmailId, this.deletedEmail);
    this.showDelete[index] = false;
    this.filterNonPrimary();
  }
  openConfirmModal(modalName: string): void {
    var modal = document.getElementById(modalName);
    modal.removeAttribute("aria-hidden");
    modal.setAttribute("class", "modal-wrapper custome-modal-wrapper modal-open");
  }
  closeConfirmModal(modalName: string): void {
    var modal = document.getElementById(modalName);
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("class", "modal-wrapper")
  }
  onOfficeEmailBlur(e: any): void {
    if (this.emailList.some(x => x.email == this.newemailform.value.emailId)) {
      this.isDuplicateEmail = true;
    }
    else {
      this.isDuplicateEmail = false;
    }
  }
  alert() {
    this.isOrgAdded = false;
    if (this.action === 'Alert') {
      this.action = 'List';

    } else {
      this.action = 'Alert';
      this.showAlert = false;
      this.showOrgForm = false;
    }
    this.orgEmailMapping = this.cService.orgList.filter(item => item.email !== "");
  }
  toggleshowOrgForm() {
    this.action = 'List';
    this.showOrgForm = true;
    this.showAlert = false;
    this.isOrgSelected = false;
  }
}
